var map = {
	"./js/位經.wy": 15,
	"./js/格物.wy": 16,
	"./js/畫譜.wy": 17,
	"./js/西曆法.wy": 18,
	"./py/位經.wy": 19,
	"./py/西曆法.wy": 20,
	"./列經.wy": 21,
	"./易經.wy": 22,
	"./曆法.wy": 23,
	"./曆表.wy": 24,
	"./渾沌經.wy": 25,
	"./算經.wy": 26,
	"./籌經.wy": 27
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14;